<template>
  <div id="app">
    <!-- 路由的出入口，路由的内容没那个将被显示在这里 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />

  </div>
</template>

<script>
// 移除DevicePixelRatio组件，它会导致不同设备上的显示比例问题
// import DevicePixelRatio from '@/utils/devicePixelRatio'
export default {
  name: 'App',
  created() {
// 移除DevicePixelRatio初始化
// new DevicePixelRatio().init()
  }
}
</script>

<style>
body {
    margin: 0;
    padding: 0;
    width: 100vw;
    height: 100vh;
    zoom: 1 !important;
    overflow-x: hidden; /* 禁止水平滚动 */
    /*background-color: #F5F5F5;*/
}
::-webkit-scrollbar {
    display: none;
}
#app {
  width: 100%;
  overflow-x: hidden; /* 防止子元素溢出导致水平滚动 */
}
</style>
